module.exports = __webpack_public_path__ + "img/grid-4-svgrepo-com.b2b59232.svg";